// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixLocation from 'wix-location'; 

$w.onReady(function () {
	//TODO: write your page related code here...
	$w('#column12').onClick(function() {
		wixLocation.to("https://www.votesmart.org");
	});
});

